import {
    transformSourceToTargetKeys,
    createDataMapper,
} from '@common/utils/query/dataMappers';
import { WORKFLOW_KEYS } from '../constants';
import { BackendWorkflowEntry, WorkflowEntry } from '../types/workflow';

const mapBackendWorkflowEntryToWorkflowEntry = (
    backendWE: BackendWorkflowEntry,
): WorkflowEntry => {
    const transformedKeys = transformSourceToTargetKeys(
        backendWE,
        WORKFLOW_KEYS,
    );

    return {
        ...transformedKeys,
    };
};

export const transformWorkflow = createDataMapper<
    BackendWorkflowEntry,
    WorkflowEntry
>(mapBackendWorkflowEntryToWorkflowEntry, true);
